import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { NoWeb3AuthGuard } from 'modules/auth/components/NoWeb3AuthGuard';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { homeRoutesConfig } from 'domains/home/routes';
import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';

const SwaggerUIPage = loadable(
  async () => {
    const module = await import('./SwaggerUIPage');

    return module.SwaggerUIPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const homePath = homeRoutesConfig.home.generatePath();
const chainsPath = chainsRoutesConfig.chains.generatePath();

export const SwaggerUIPageContainer = () => {
  return (
    <NoSSRGuard>
      <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
        <NoWeb3AuthGuard fallback={<Navigate to={homePath} />}>
          <SwaggerUIPage />
        </NoWeb3AuthGuard>
      </LoggingInGuard>
    </NoSSRGuard>
  );
};
